<button [attr.data-comp]="'FiltersItem'" (click)="onClickItem()" class="item inner">
  <div class="label-md left">
    <h2 class="ellipses-label">{{config.localization.button}}</h2>
  </div>
  <div class="right"><app-item-arrow /></div>
</button>
<mat-divider class="divider" />

